import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import {InboxState} from '../reducers/inbox.reducers';

export const getInboxState = createFeatureSelector<InboxState>(
  'inbox'
);

export const getInvalidateId = createSelector(
  getInboxState,
  (state: InboxState) => state.invalidateId
);
export const getInboxLabels = createSelector(
  getInboxState,
  (state: InboxState) => state.inboxLabels
);
export const getCurrentMail = createSelector(
  getInboxState,
  (state: InboxState) => state.currentlyOpenedMail
);
export const getAllRecepients = createSelector(
  getInboxState,
  (state: InboxState) => state.allRecepients
);
export const getInboxAlertMessage = createSelector(
  getInboxState,
  (state: InboxState) => state.inboxAlertMessage
);
